// app/services/causeOfCall.service.js
import { api } from './api';

class CauseOfCallService {
    // Get cause of calls by parent ID and scheme ID
    async getCauseOfCalls(schemeId, parentId = null, activeOnly = true) {
        const params = { active_only: activeOnly };
        if (parentId !== null) {
            params.parent_id = parentId;
        }
        const queryString = new URLSearchParams(params).toString();
        return api.get(`/api/admin/scheme-cause-of-calls/${schemeId}?${queryString}`);
    }

    // Get single cause of call
    async getCauseOfCallById(causeId) {
        return api.get(`/api/admin/cause-of-calls/${causeId}`);
    }

    // Create new cause of call
    async createCauseOfCall(causeData) {
        return api.post('/api/admin/cause-of-calls', causeData);
    }

    // Update cause of call
    async updateCauseOfCall(causeId, causeData) {
        return api.put(`/api/admin/cause-of-calls/${causeId}`, causeData);
    }

    // Delete cause of call
    async deleteCauseOfCall(causeId) {
        return api.delete(`/api/admin/cause-of-calls/${causeId}`);
    }

    // Get full hierarchy
    async getCauseHierarchy(schemeId) {
        return api.get(`/api/admin/scheme-cause-of-calls/${schemeId}`);
    }
}

export const causeOfCallService = new CauseOfCallService();